import DashboardSwitcher from './DashboardSwitcher';

export default DashboardSwitcher;
